export default {
  'Please select an output format': 'من فضلك حدد تنسيق المخرجات',
}